<template>
  <div class="app-ordering" :class="'step-' + this.getCurrentStep">
    <div class="main-content">
      <div class="container">
        <StepsBar :current-step="getCurrentStep" :steps="orderingSteps" @onStepClick="changeStep" @goBack="goToPreviousStep">
          <template v-for="slot in possibleChildSlotsFor('CheckoutSteps')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </StepsBar>
        <MnpData :ref="getCurrentStep" @goForward="goToNextStep" v-if="getCurrentStep === 'mnpData'" @updatedMnpActive="updateCart()" @updatedProvider="updateCart(false)">
          <template v-for="slot in possibleChildSlotsFor('MnpData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpData>
        <CustomerData :ref="getCurrentStep" @goBack="goToPreviousStep" @goForward="goToNextStep" v-if="getCurrentStep === 'customerData'">
          <template v-for="slot in possibleChildSlotsFor('CustomerData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </CustomerData>
        <SimData  :ref="getCurrentStep" @goBack="goToPreviousStep" @goForward="goToNextStep" v-if="getCurrentStep === 'simData'" @update-disable="handleDisableUpdate">
          <template v-for="slot in possibleChildSlotsFor('IdentData')" v-slot:[`${slot.parent}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="slot in possibleChildSlotsFor('SimData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </SimData>
        <PaymentData :ref="getCurrentStep" @goBack="goToPreviousStep" @goForward="goToNextStep" v-if="getCurrentStep === 'paymentData'">
          <template v-for="slot in possibleChildSlotsFor('PaymentData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </PaymentData>
        <Summary
          @goBack="goToPreviousStep"
          @goForward="goToNextStep"
          @onStepClick="changeStep"
          v-if="getCurrentStep === 'summary'"
          :promoBenefits="promoBenefits"
          :voucherPromotions="voucherPromotions"
          :showPriceStarts="showPriceStarts">
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="cartSlot in possibleChildSlotsFor('Cart')" v-slot:[`${cartSlot.parent}`]>
            <slot :name="`${cartSlot.parent}`"></slot>
          </template>
          <template v-for="tokenSlot in possibleChildSlotsFor('TokenHandler')" v-slot:[`${tokenSlot.parent}`]>
            <slot :name="`${tokenSlot.parent}`"></slot>
          </template>
          <template v-for="voucherBoxSlot in possibleChildSlotsFor('VoucherBox')" v-slot:[`${voucherBoxSlot.parent}`]>
            <slot :name="`${voucherBoxSlot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.parent}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </Summary>
      </div>
    </div>
    <div id="cart-sidebar" class="sidebar">
      <div class="container">
        <Cart :promoBenefits="promoBenefits" :voucherPromotions="voucherPromotions" :showPriceStarts="showPriceStarts" class="card">
          <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </Cart>
        <VoucherBox class="card" @open-collapse="$refs.tokenHandlerRef.openCollapse()">
          <template v-for="slot in possibleChildSlotsFor('VoucherBox')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="tokenSlot in possibleChildSlotsFor('TokenHandler')" v-slot:[`${tokenSlot.child}`]>
            <slot :name="`${tokenSlot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </VoucherBox>
        <TokenHandler process="ordering" class="card" ref="tokenHandlerRef">
          <template v-for="slot in possibleChildSlotsFor('TokenHandler')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="voucherSlot in possibleChildSlotsFor('VoucherSlots')" v-slot:[`${voucherSlot.child}`]>
            <slot :name="`${voucherSlot.parent}`"></slot>
          </template>
        </TokenHandler>
      </div>
      <Stepper
        class="mobile-stepper"
        :loading-next="loading"
        :disabledNext="getCurrentStep === 'simData' && simData.simType === 'E_SIM' ? disableNextButton : false"
        :show-prev=showPrevBtn()
        @prev=goToPreviousStep
        @next="next()"
      >
        <template v-for="slot in possibleChildSlotsFor(mobileStepperSlots)" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </div>
    <StickyCart v-if="getCurrentStep !== 'summary'"
                :promoBenefits="promoBenefits"
                :showPriceStarts="showPriceStarts"
    >
      <template v-for="slot in possibleChildSlotsFor('Cart')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </StickyCart>
  </div>
</template>

<script>
import StepsBar from '@/components/checkout/StepsBar.vue'
import Cart from '@/components/checkout/cart/Cart.vue'
import TokenHandler from '@/components/checkout/cart/TokenHandler.vue'
import VoucherBox from '@/components/checkout/cart/VoucherBox.vue'
import StickyCart from '@/components/checkout/cart/StickyCart.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MnpData from '@/components/checkout/mnpData/MnpData.vue'
import CustomerData from '@/components/checkout/customerData/CustomerData.vue'
import SimData from '@/components/checkout/simData/SimData.vue'
import Summary from '@/components/checkout/ordering/Summary.vue'
import PaymentData from '@/components/checkout/paymentData/PaymentData.vue'
import { checkoutTracking } from '@/helper/checkoutTracking'
import trackingHandler from '@/mixins/trackingHandler'
import Stepper from '@/components/generic/Stepper.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'Ordering',
  components: { MnpData, CustomerData, SimData, PaymentData, Summary, StepsBar, Cart, StickyCart, TokenHandler, Stepper, VoucherBox },
  props: {
    availableDeviceTypes: {
      type: String,
      default: ''
    },
    quickSelectionCountryIdent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      orderingSteps: ['mnpData', 'customerData', 'simData', 'paymentData', 'summary'],
      loading: false,
      disableNextButton: true
    }
  },
  mounted () {
    const kwkPromotionIds = window.$feconfig?.promotion?.kwkIds || []
    this.setKwkPromoIds(kwkPromotionIds)
    this.updateCart()
  },
  mixins: [
    trackingHandler,
    transaction('ordering')
  ],
  methods: {
    ...mapMutations('checkoutv2/ordering', ['setStep']),
    ...mapMutations('checkoutv2/ordering/_cart', ['setKwkPromoIds']),
    ...mapActions('checkoutv2/ordering/_cart', ['queryCart']),
    changeStep (step) {
      this.setStep(step)
      this.triggerPageviewTracking(this.orderingSteps.indexOf(step))
      window.scrollTo(0, 0)
      this.$nextTick(() => {
        this.focusStep()
      })
    },
    updateCart (triggerPageview = true) {
      this.startLoader()
      this.queryCart({})
        .then(() => {
          if (triggerPageview) {
            this.triggerPageviewTracking()
          }
        })
        .catch((error) => {
          this.errorToast(this.getErrorMessage(error))
          this.triggerErrorTracking(error)
        })
        .finally(() => {
          this.stopLoader()
        })
    },
    goToPreviousStep () {
      const newIndex = Math.max(0, (this.orderingSteps.indexOf(this.getCurrentStep) - 1))
      this.step(newIndex)
      this.$nextTick(() => {
        this.focusStep()
      })
    },
    goToNextStep () {
      const newIndex = Math.min((this.orderingSteps.length - 1), (this.orderingSteps.indexOf(this.getCurrentStep) + 1))
      this.step(newIndex)
      this.$nextTick(() => {
        this.focusStep()
      })
    },
    step (newIndex) {
      this.setStep(this.orderingSteps[newIndex])
      this.triggerPageviewTracking(newIndex)
      window.scrollTo(0, 0)
    },
    focusStep () {
      const spanElement = document.querySelector('.' + this.getCurrentStep + ' .label')
      spanElement.focus()
    },
    next () {
      this.$refs[this.getCurrentStep].save()
    },
    showPrevBtn () {
      return this.getCurrentStep !== 'mnpData'
    },
    triggerPageviewTracking (stepIndex = this.orderingSteps.indexOf(this.getCurrentStep)) {
      checkoutTracking('ordering', this.$store, this.orderingSteps[stepIndex], stepIndex + 1)
    },
    handleDisableUpdate (value) {
      this.disableNextButton = value
    }
  },
  computed: {
    ...mapGetters('checkoutv2/ordering/_cart', ['targetTariff', 'voucherPromotions', 'promoBenefits', 'kwkToken']),
    ...mapGetters('checkoutv2/ordering/_mnpData', { mnpActive: 'active', mnpProvider: 'provider' }),
    ...mapGetters('checkoutv2/ordering/_simData', ['simData']),
    getCurrentStep: function () {
      return this.$store.getters['checkoutv2/ordering/step']
    },
    showPriceStarts: function () {
      return this.kwkToken === null && (this.mnpActive === true && (!this.mnpProvider.key || this.mnpProvider.unportable))
    },
    mobileStepperSlots: function () {
      if (this.getCurrentStep === 'mnpData' && this.mnpActive === true) {
        return 'MnpStepper' + this.getCurrentStep.charAt(0).toUpperCase() + this.getCurrentStep.slice(1)
      } else {
        return 'Stepper' + this.getCurrentStep.charAt(0).toUpperCase() + this.getCurrentStep.slice(1)
      }
    }
  }
}
</script>
